import React, { useState, useMemo } from 'react'
import { Outlet, useOutletContext, useLocation } from 'react-router-dom'
import { Content } from './style'
import {
  OptionsButton,
  LeftSide,
  RightSide,
  SectionName,
  SubHeaderContainer,
  ButtonCreate,
  RefreshIcon,
  RefreshIconContainer,
  TabsDiv,
  Tab,
} from '../../../components/styles/subheader-style'
import refresh_act from '../../../assets/refresh-active.svg'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { Plus } from 'lucide-react'
import filterIcon from '../../../assets/stock/TableMovementHeader/filter.svg'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import resource from '../../../assets/home/resource.svg'
import length from '../../../assets/home/length.svg'

interface TypeMainOutlet {
  search: string
}

export interface ProductCompositionOutletType {
  refresh: boolean
  search: string
  isLoading?: boolean
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>
  Styled: {
    GlobalTable: any
    HeaderLine: any
    Th: any
    Tr: any
    Td: any
    TdButtons: any
    DivInTd: any
    InfoMessage: any
  }
}


const GlobalTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: 'Inter', sans-serif;
`

const HeaderLine = styled.tr``

const Th = styled.th`
  position: sticky;
  top: 0;
  background-color: #f4f4f4;
  z-index: 10;
  text-align: left;
  padding: 18px;
  font-size: 13px;
  font-weight: 500;
  color: #8d8d8d;
  border-bottom: 1px solid transparent;
  white-space: nowrap;
  cursor: default;
`

const Tr = styled.tr`
  background-color: #ffffff;
  transition: all 0.2s ease;
`

const Td = styled.td`
  padding: 18px;
  font-size: 15px;
  color: #303030;
  background-color: #ffffff;
  border-bottom: 1px solid #f4f4f4;
  vertical-align: middle;
  white-space: nowrap;

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`

const TdButtons = styled.td`
  padding: 16px;
  text-align: right;
  white-space: nowrap;
`

const DivInTd = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px;
  margin-left: 8px;

  &:hover {
    opacity: 0.7;
  }

  img {
    width: 20px;
    height: 20px;
  }
`

const InfoMessage = styled.div`
  padding: 60px 40px;
  text-align: center;
  color: #999;
  font-size: 16px;
  background-color: white;
  border-radius: 8px;
`
const compositionTabs = [
  { path: '/panel/stock', image: stock, name: 'Tecido' },
  { path: '/panel/stock/resource', image: resource, name: 'Aviamentos' },
  { path: '/panel/product-composition', image: length, name: 'Composição de produto' },
]

export const ProductCompositionSubHeader: React.FC<{
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
  isLoading?: boolean
}> = ({ setRefresh, isLoading }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const activeIndex = (() => {
    if (location.pathname.includes('/panel/stock/resource')) return 1
    if (location.pathname.includes('/panel/product-composition')) return 2
    return 0
  })()

  const isFormPage = location.pathname.includes('/panel/product-composition/create') ||
    location.pathname.includes('/panel/product-composition/edit')

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>Estoque</SectionName>
        {!isFormPage && (
          <TabsDiv>
            {compositionTabs.map((tab, index) => (
              <Tab
                key={index}
                $isFirst={index === 0}
                $isLast={index === compositionTabs.length - 1}
                $isActive={index === activeIndex}
                onClick={() => {
                  if (index !== activeIndex) {
                    navigate(tab.path)
                  }
                }}
              >
                <img src={tab.image} alt={`${tab.name}-icon`} />
                {tab.name}
              </Tab>
            ))}
          </TabsDiv>
        )}
      </LeftSide>
      <RightSide>
        <RefreshIconContainer onClick={() => setRefresh(prev => !prev)} title="Atualizar">
          <RefreshIcon src={refresh_act} alt="Atualizar" $spinning={isLoading} />
        </RefreshIconContainer>
        <ButtonCreate onClick={() => navigate('/panel/product-composition/create')}>
          <Plus size={18} />
          Novo produto
        </ButtonCreate>
      </RightSide>
    </SubHeaderContainer>
  )
}

const ProductCompositionContent = () => {
  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { search } = useOutletContext<TypeMainOutlet>()
  const location = useLocation()

  const isFormPage = location.pathname.includes('/panel/product-composition/create') ||
    location.pathname.includes('/panel/product-composition/edit')

  const outletContext: ProductCompositionOutletType = useMemo(
    () => ({
      refresh,
      search,
      isLoading,
      setIsLoading,
      Styled: {
        GlobalTable,
        HeaderLine,
        Th,
        Tr,
        Td,
        TdButtons,
        DivInTd,
        InfoMessage,
      },
    }),
    [refresh, search],
  )

  return (
    <>
      {!isFormPage && <ProductCompositionSubHeader setRefresh={setRefresh} isLoading={isLoading} />}
      <Content>
        <Outlet context={outletContext} />
      </Content>
    </>
  )
}

export default ProductCompositionContent